export const messages = {
  en: {
    marketRule: {
      title: 'Marketing Rule Management',
      name: 'Name',
      description: 'Description',
      marketingMethod: 'Marketing Method',
      communityAuthorization: 'Community Authorization',
      targetObject: 'Target Object',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMessage: 'Are you sure to delete this marketing rule?',
      marketingType: 'Marketing Type',
      remark: 'Remark',
      operation: 'Operation',
      communityName: 'Community Name',
      communityId: 'Community ID',
      objectName: 'Object Name',
      associateMarketingMethod: 'Associate Marketing Method',
      associateCommunity: 'Associate Community',
      associateObject: 'Associate Object',
      text: 'Text',
      image: 'Image',
      goods: 'Goods',
      required: 'Required',
      selectMarketingType: 'Please select marketing type',
      selectMarketingText: 'Please select marketing text',
      selectMarketingImage: 'Please select marketing image',
      selectMarketingGoods: 'Please select marketing goods',
      selectCommunity: 'Please select community',
      selectObject: 'Please select object',
      customer: 'Customer',
      merchant: 'Merchant',
      staff: 'Staff'
    }
  },
  zh: {
    marketRule: {
      title: '营销规则管理',
      name: '名称',
      description: '描述',
      marketingMethod: '营销方式',
      communityAuthorization: '小区授权',
      targetObject: '作用对象',
      add: '添加',
      edit: '修改',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      confirmDelete: '确认删除',
      deleteConfirmMessage: '确定删除营销规则?',
      marketingType: '营销类型',
      remark: '备注',
      operation: '操作',
      communityName: '小区名称',
      communityId: '小区编号',
      objectName: '对象名称',
      associateMarketingMethod: '关联营销方式',
      associateCommunity: '关联小区',
      associateObject: '关联对象',
      text: '文本',
      image: '图片',
      goods: '商品',
      required: '必填',
      selectMarketingType: '请选择营销类型',
      selectMarketingText: '请选择营销文本',
      selectMarketingImage: '请选择营销图片',
      selectMarketingGoods: '请选择营销商品',
      selectCommunity: '请选择小区',
      selectObject: '请选择对象',
      customer: '客户',
      merchant: '商户',
staff: '员工'
    }
  },
  'zh-TW': {
    marketRule: {
      title: '營銷規則管理',
      name: '名稱',
      description: '描述',
      marketingMethod: '營銷方式',
      communityAuthorization: '小區授權',
      targetObject: '作用對象',
      add: '新增',
      edit: '修改',
      delete: '刪除',
      save: '儲存',
      cancel: '取消',
      confirmDelete: '確認刪除',
      deleteConfirmMessage: '確定刪除營銷規則?',
      marketingType: '營銷類型',
      remark: '備註',
      operation: '操作',
      communityName: '小區名稱',
      communityId: '小區編號',
      objectName: '對象名稱',
      associateMarketingMethod: '關聯營銷方式',
      associateCommunity: '關聯小區',
      associateObject: '關聯對象',
      text: '文本',
      image: '圖片',
      goods: '商品',
      required: '必填',
      selectMarketingType: '請選擇營銷類型',
      selectMarketingText: '請選擇營銷文本',
      selectMarketingImage: '請選擇營銷圖片',
      selectMarketingGoods: '請選擇營銷商品',
      selectCommunity: '請選擇小區',
      selectObject: '請選擇對象',
      customer: '客戶',
      merchant: '商戶',
      staff: '員工'
    }
  }
}